import { render, staticRenderFns } from "./historyPage.vue?vue&type=template&id=5beeec5a&scoped=true"
import script from "./historyPage.vue?vue&type=script&lang=js"
export * from "./historyPage.vue?vue&type=script&lang=js"
import style0 from "./historyPage.vue?vue&type=style&index=0&id=5beeec5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beeec5a",
  null
  
)

export default component.exports